import React, { useMemo, useEffect } from 'react';
import { User } from 'lucide-react';
import useClientesModel from '../../../../modelos/Clientes/modeloClientes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CardProPlataforma from './Modulos/CardProPlataforma';
import { useDashboardModel } from '../../../../modelos/Dashboard/modeloDashboard';

  
const ProPlataforma = () => {
  const {
    clientesProUnad,
    loadingClientes,
    errorClientes,
    cargarClientesProPlataforma,
  } = useClientesModel();

  const{
    estadisticasProUnad,
    LoadingestadisticasProUnad,
    errorestadisticasProUnad,

    cargarEstadisticasProUnad,
  } = useDashboardModel();
  
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTabEspecial = searchParams.get('estado') || 'TODOS';
  const activeTabCurso = searchParams.get('curso_estado') || 'TODOS';


  const navigate = useNavigate();

  //actualizar parametros de url
  const handleTabEspecialClick = (nuevoEstado) => {
    const newParams = new URLSearchParams(searchParams);
    if (nuevoEstado === 'TODOS') {
      newParams.delete('estado');
    } else {
      newParams.set('estado', nuevoEstado);
    }
    // Si el nuevo estado no es 'TRABAJANDO', eliminamos el filtro del curso para una URL limpia.
    if (nuevoEstado !== 'TRABAJANDO') {
      newParams.delete('curso_estado');
    }
    setSearchParams(newParams);
  };

  const handleTabCursoClick = (nuevoEstado) => {
    const newParams = new URLSearchParams(searchParams);
    if (nuevoEstado === 'TODOS') {
      newParams.delete('curso_estado');
    } else {
      newParams.set('curso_estado', nuevoEstado);
    }
    setSearchParams(newParams);
  };

  const formatCursoLabel = (status) => {
    if (!status) return 'Sin Estado';
    return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()); // Reemplaza '_' por espacio y capitaliza
  };

  //tabs de control general
  const countsByStatus = useMemo(() => {
    const counts = {
      TODOS: clientesProUnad.length,
      COTIZACION_PASADA: 0,
      COTIZANDO: 0,
      CONTACTO_CLIENTE: 0,
      NO_ACCESO_PLATAFORMA: 0,
      TRABAJANDO: 0,
    };
    for (const cliente of clientesProUnad) {
      if (counts[cliente.estadoClienteEspecial] !== undefined) {
        counts[cliente.estadoClienteEspecial]++;
      }
    }
    return counts;
  }, [clientesProUnad]);
  const TABS_ESPECIAL = [
    { id: 'TODOS', label: 'Todos', count: countsByStatus.TODOS, color: 'gray' },
    { id: 'CONTACTO_CLIENTE', label: 'Contacto', count: countsByStatus.CONTACTO_CLIENTE, color: 'blue' },
    { id: 'NO_ACCESO_PLATAFORMA', label: 'Sin Acceso', count: countsByStatus.NO_ACCESO_PLATAFORMA, color: 'red' },
    { id: 'COTIZANDO', label: 'Cotizando', count: countsByStatus.COTIZANDO, color: 'orange' },
    { id: 'COTIZACION_PASADA', label: 'Cotización Pasada', count: countsByStatus.COTIZACION_PASADA, color: 'green' },
    { id: 'TRABAJANDO', label: 'Trabajando en plataforma', count: countsByStatus.TRABAJANDO, color: 'green' },
  ];

  //tabs de control de cursos
  const countsByCursoStatus = useMemo(() => {
    // 1. Filtramos para obtener SOLO los clientes que están en estado 'TRABAJANDO'.
    const clientesEnTrabajo = clientesProUnad.filter(
      (cliente) => cliente.estadoClienteEspecial === 'TRABAJANDO'
    );

    // 2. 'TODOS' ahora es el total de clientes 'TRABAJANDO', no el total general.
    const counts = { TODOS: clientesEnTrabajo.length };

    // 3. Iteramos sobre la lista ya filtrada para contar los estados del curso.
    for (const cliente of clientesEnTrabajo) {
      const status = cliente.estadoTrabajoUnadCurso || 'SIN_ESTADO'; // Agrupa los nulos/undefined
      counts[status] = (counts[status] || 0) + 1;
    }
    
    return counts;
  }, [clientesProUnad]);
  const TABS_CURSO = useMemo(() => {
    const tabs = [{ id: 'TODOS', label: 'Todos', count: countsByCursoStatus.TODOS, color: 'gray' }];
    Object.keys(countsByCursoStatus)
      .filter(key => key !== 'TODOS')
      .sort() // Ordenar alfabéticamente para consistencia
      .forEach(statusKey => {
        tabs.push({
          id: statusKey,
          label: formatCursoLabel(statusKey),
          count: countsByCursoStatus[statusKey],
          color: 'indigo' // Un color base para estas tabs
        });
      });
    return tabs;
  }, [countsByCursoStatus]);
  
  
  useEffect(() => {
    cargarClientesProPlataforma();
  }, []);

  useEffect(() =>{
    cargarEstadisticasProUnad("DUFY%20ASESORIAS","2026-1");
  },[]);

  // Función para seleccionar cliente
  const seleccionarCliente = (cliente) => {
    navigate(`/dashboard/plataforma/DUFY%20ASESORIAS/${cliente.numero}`);
  };
  
  const getRowColorClass = (estado) => {
    switch (estado) {
      case 'COTIZACION_PASADA':
        return 'bg-green-100 hover:bg-green-200'; // Verde
      case 'COTIZANDO':
        return 'bg-orange-100 hover:bg-orange-200'; // Naranja
      case 'CONTACTO_CLIENTE':
        return 'bg-blue-100 hover:bg-blue-200'; // Azul
      case 'NO_ACCESO_PLATAFORMA':
        return 'bg-red-100 hover:bg-red-200'; // Rojo
      default:
        return 'bg-white hover:bg-gray-50'; // Color por defecto
    }
  };

  const estadisticasMap = useMemo(() => {
  if (!estadisticasProUnad) return new Map();
  // Creamos un mapa donde la clave es el 'numeroCliente' y el valor es el objeto de estadística.
  return new Map(estadisticasProUnad.map(stat => [stat.numeroCliente, stat]));
}, [estadisticasProUnad]);


  const clientesConEstadisticas = useMemo(() => {
    // Mapeamos sobre la lista original de clientes
    return clientesProUnad.map(cliente => {
      // Buscamos la estadística correspondiente en nuestro mapa (búsqueda instantánea)
      const estadisticas = estadisticasMap.get(cliente.numero);
      
      // Devolvemos un nuevo objeto que combina ambos
      return {
        ...cliente, // Toda la información original del cliente
        estadisticas: estadisticas || null // Añadimos el objeto de estadísticas (o null si no se encuentra)
      };
    });
  }, [clientesProUnad, estadisticasMap]);

  const clientesFiltrados = useMemo(() => {
    let resultado = clientesConEstadisticas; // <-- CAMBIO AQUÍ

    if (activeTabEspecial !== 'TODOS') {
      resultado = resultado.filter(cliente => cliente.estadoClienteEspecial === activeTabEspecial);
    }

    if (activeTabEspecial === 'TRABAJANDO' && activeTabCurso !== 'TODOS') {
      resultado = resultado.filter(cliente => (cliente.estadoTrabajoUnadCurso || 'SIN_ESTADO') === activeTabCurso);
    }

    return resultado;
  }, [clientesConEstadisticas, activeTabEspecial, activeTabCurso]); 


   if (loadingClientes) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Cargando clientes...</p>
        </div>
      </div>
    );
  }

  if (errorClientes) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center text-red-600">
          <p>Error al cargar clientes: {errorClientes}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Clientes Pro Plataforma UNAD
        </h1>
        <p className="text-gray-600">
          Mostrando {clientesFiltrados.length} de {clientesProUnad.length} clientes especiales.
        </p>
      </div>

      {/* --- ⭐ NUEVA SECCIÓN: LEYENDA DE COLORES --- */}
      <div className="mb-6 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
        <h3 className="text-md font-semibold text-gray-700 mb-3">Leyenda de Estados:</h3>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <div className="flex items-center">
            <span className="h-4 w-4 rounded-full bg-green-200 mr-2 border border-green-300"></span>
            <span className="text-sm text-gray-600">Cotización Pasada</span>
          </div>
          <div className="flex items-center">
            <span className="h-4 w-4 rounded-full bg-orange-200 mr-2 border border-orange-300"></span>
            <span className="text-sm text-gray-600">Cotizando</span>
          </div>
          <div className="flex items-center">
            <span className="h-4 w-4 rounded-full bg-blue-200 mr-2 border border-blue-300"></span>
            <span className="text-sm text-gray-600">Contacto con Cliente</span>
          </div>
          <div className="flex items-center">
            <span className="h-4 w-4 rounded-full bg-red-200 mr-2 border border-red-300"></span>
            <span className="text-sm text-gray-600">Sin Acceso a Plataforma</span>
          </div>
        </div>
      </div>

      {/* --- ⭐ NUEVA SECCIÓN: PESTAÑAS DE NAVEGACIÓN --- */}
      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-6 overflow-x-auto" aria-label="Tabs">
            {TABS_ESPECIAL.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabEspecialClick(tab.id)}
                className={`
                  ${activeTabEspecial === tab.id
                    ? `border-${tab.color || 'blue'}-500 text-${tab.color || 'blue'}-600`
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                  whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-200
                `}
              >
                {tab.label}
                <span
                  className={`
                    ${activeTabEspecial === tab.id ? `bg-${tab.color}-100 text-${tab.color}-600` : 'bg-gray-100 text-gray-600'}
                    ml-2 py-0.5 px-2 rounded-full text-xs font-semibold
                  `}
                >
                  {tab.count}
                </span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* --- FILTRO POR AVANCE DEL CURSO --- */}
      {activeTabEspecial === "TRABAJANDO" && (
        <div className="mb-6">
          <h3 className="text-md font-semibold text-gray-700 mb-2">Filtrar por Avance del Curso:</h3>
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-6 overflow-x-auto" aria-label="Tabs">
              {TABS_CURSO.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabCursoClick(tab.id)}
                  className={`
                    ${activeTabCurso === tab.id
                      ? `border-${tab.color}-500 text-${tab.color}-600`
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                    whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-200
                  `}
                >
                  {tab.label}
                  <span
                    className={`
                      ${activeTabCurso === tab.id ? `bg-${tab.color}-100 text-${tab.color}-600` : 'bg-gray-100 text-gray-600'}
                      ml-2 py-0.5 px-2 rounded-full text-xs font-semibold
                    `}
                  >
                    {tab.count}
                  </span>
                </button>
              ))}
            </nav>
          </div>
        </div>
      )}
     


      {clientesFiltrados.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <User className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <p className="text-gray-500 text-lg">
            No hay clientes en el estado "{TABS_ESPECIAL.find(t => t.id === activeTabEspecial)?.label}"
          </p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Cliente
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Información Académica
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Avance plataforma
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                
                {clientesFiltrados.map((cliente, index) => (
                  <CardProPlataforma
                    key={cliente.numero || index}
                    cliente={cliente}
                    className={`${getRowColorClass(cliente.estadoClienteEspecial)} cursor-pointer transition-colors duration-200`}
                    onClick={() => seleccionarCliente(cliente)}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

    </div>
  );

};

export default ProPlataforma;